import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getAnswers } from "slices/answerSlice";
import { getUserFiles } from "slices/disputeSlice";
import { getQuestions, getSubQuestions } from "slices/questionSlice";
import DetailsReview from "./DetailsReview";
import { isMuthoot, isOrix } from "Routes/Routes";
import { REOPEN_INPROGRESS } from "app/constants";

export default function DetailsReviewContainer({ profile }) {
  let dispatch = useDispatch();

  let {
    // questions: { questions },
    // answers: { answers },
    disputes: { activeDispute, userFiles: files },
    cases: { activeCase },
  } = useSelector((state) => state, shallowEqual);

  const [questions, setQuestions] = useState();
  const [answers, setAnswers] = useState();

  // let loading = isEmpty(questions) || isEmpty(answers);

  const [questionsloading, setQuestionsloading] = useState(true);
  const [answerlaoding, setAnswerlaoding] = useState(true);

  const [userFiles, setUserFiles] = useState([]);

  const getQuestionsAnswers = () => {
    setAnswers([]);
    if ((isOrix || isMuthoot) && activeDispute?.status !== 'new') {
      dispatch(getSubQuestions(activeDispute.company_product, activeCase.type, activeDispute?.status === REOPEN_INPROGRESS ? 'dispute reopen' : 'additional details')).then(
        (res) => {
          setQuestions(res.results);
          setQuestionsloading(false);
        }
      );
    } else {
      dispatch(getQuestions(activeDispute.company_product, activeCase.type)).then(
        (res) => {
          setQuestions(res.results);
          setQuestionsloading(false);
        }
      );
    }

    dispatch(getAnswers(activeCase.id)).then((res) => {
      setAnswers(res.results);
      setAnswerlaoding(false);
    });
  };

  useEffect(() => {
    getQuestionsAnswers();
    dispatch(getUserFiles(activeDispute.id));
  }, []);

  useEffect(() => {
    if (isOrix && answers?.length > 0 && questions?.length > 0) {
      questions.map((question, index) => {
        if (question.name === 'Complaint Category') {
          let answer = answers.find((ans) => ans.question === question.id);
          if (answer?.ground === "Ground 4" || answer?.ground === "Ground 7") {
            dispatch(getSubQuestions(activeDispute.company_product, activeCase.type, answer?.value)).then((res) => {
              if (JSON.stringify(questions) !== JSON.stringify(res.results)) { // check for deep equal
                setQuestions(res.results);
              }
              setQuestionsloading(false);
            })
          }
        }
      });
    }
  }, [questions, answers])

  React.useEffect(() => {
    let f = [];
    files.forEach((file) => {
      if (file.is_attachment) {
        f.push(file);
      }
    });
    setUserFiles(f);
  }, [files]);

  let childProps = {
    activeCase,
    activeDispute,
    questions,
    answers,
    profile,
    userFiles,
    getQuestionsAnswers,
  };

  return (
    <React.Fragment>
      {!questionsloading && !answerlaoding ? (
        <DetailsReview {...childProps} />
      ) : (
        <CircularProgress />
      )}
    </React.Fragment>
  );
}
